<template>
  <Layou class="px_1" header mian footer>
    <template v-slot:header>
      <el-row class="logo_header" style="display: block;">

        <el-col class="logo_header_box">
          <div class="logo_img">
          <el-image :src="logo"> </el-image>
        </div>
          <div  class="titile_logo"><a href="/">MxDraw云图帮助</a></div>
        </el-col>
      </el-row>


     </template>
    <template v-slot:main>
      <div class="main">
    <div class="fiex">
      <div class="login">
        <el-image :src="src"></el-image>

      </div>
      <div class="card">
        <el-card shadow="always">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick" :stretch="true" class="user_tabs">
            <el-tab-pane label="找回密码" name="first">
              <div class="user_register">
                <div class="input_text inpup_first">

                  <el-input placeholder="请输入手机号" v-model="mobile" @focus="clearErrInput" maxlength="11">
                    <template slot="prepend">+86</template>
                  </el-input>
                </div>
                <div>
                   <el-input placeholder="请输入验证码" v-model="code" maxlength=4 @focus="clearErrInput">
                    <template slot="append"><div v-html="tpcode" class="tpcode_div" @click="cutTpCode" title="看不清?点击换一张"></div></template>
                  </el-input>
                </div>
                <div class="input_text input_err_tips" id="LoginErr">                 
                  {{errTips}}
                </div>

                <el-button type="primary" @click="next" class="next_to">下一步</el-button>
              </div>

            </el-tab-pane>
            <el-tab-pane label="登录">
            </el-tab-pane>
          </el-tabs>


        </el-card>
      </div>

    </div>
      </div>
    </template>
    <template v-slot:footer>
      成都梦想凯德科技有限公司   版权所有  Copyright @ 2016 All Rights Reserved<span style="margin-left:10px;"><a href="http://www.miitbeian.gov.cn/" style="color:#999;">蜀ICP备15011727号</a></span>
      <div class="link" style=" font-size: 14px;">友情链接 | <a href="http://www.ddooo.com" target="_blank">多多软件站</a> | <a href="http://www.crsky.com" target="_blank">非凡软件站</a> | <a href="http://xiazai.zol.com.cn" target="_blank">ZOL应用下载</a> | <a href="http://mydown.yesky.com" target="_blank">天极下载</a></div>
   </template>
  </Layou>
</template>
<script>
import Layou from "./Layou/index.vue";

    export default {
        name: "login",
        components: {
            Layou,
                  },
        data(){
            return{
                src:require('../assets/img/forgetpassword.jpg'),
                logo:require('../assets/img/logo2.png'),
                mobile: '',
                code:'',
                tpcode:'',
                errTips:'',
                activeName: 'first'
            }

        },
        mounted:function(){
           this.get();
        },
        methods: {
             
             handleClick(tab, event) {
                if(tab.label==='登录') this.$router.push('login')
            },
            get(){
              var that = this;
              //发送get请求
              this.$api.get("/resetpwd").then(function(res){      
                that.tpcode = res.data.tpcode;                   
              },function(){
                that.$message.error('服务器异常，请稍后重试！');   
              });
            },
            clearErrInput(){
              //关闭账号密码登录错误提示
              document.getElementById("LoginErr").style.visibility="hidden"
            },
             cutTpCode(){
                 var that = this;
                    //切换验证码
                  this.$api.post("/tpCode3").then(function(res){          
                    that.tpcode = res.data.yzm

                  },function(){
                    that.$message.error('服务器异常，请稍后重试！');   
                  });
              },
            next(){
              var that = this;
              var mobile = that.mobile;
              var code = that.code;
              if(!mobile||!(/^1[3456789]\d{9}$/.test(mobile))){
                  that.errTips = "请输入正确的手机号"
                  document.getElementById("LoginErr").style.visibility="";
                  return;
              }
              if(!code){
                  that.errTips = "请输入验证码"
                  document.getElementById("LoginErr").style.visibility="";
                  return;
              }
              this.$api.post("/checkuser",{mobile:mobile,code:code}).then(function(res){          
                    if(res.data.code=='success'){
                      window.location.href = '/newpwd?mobile='+mobile
                    }else{
                      that.errTips = res.data.msg
                      document.getElementById("LoginErr").style.visibility="";
                    }

                  },function(){
                    that.$message.error('服务器异常，请稍后重试！');   
                  });

            }
        }
    }
</script>

<style scoped="scoped">

.logo_header,
.logo_footer {
  /*background-color: #B3C0D1;*/
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: 1px solid #e6e6e6;
}
  .logo_img {
  width: 60px;
  height: 60px;
  line-height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo_footer_btm {
  border-bottom: 1px solid #e6e6e6;
}
.logo_header {
  width: 100%;
  height: 57px;
  line-height: 57px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(9, 31, 111, 0.13);
}
.logo_header_box {
  display: block;
  position: relative;
  height: 57px;
  width: 1250px;
  margin: 0px 450px;
}

  .titile_logo{
      line-height: 60px;
      float: left;
      cursor: pointer;
  }

  .titile_logo a{
    color: #333;
    text-decoration:none;
     font-weight: 600;
    font-size: 1.3rem;
  }


.card {
  float: left;
  width: 100%;
  max-width: 420px;
}

  .input_text{
    /*width: 380px;*/
    /*margin-left: 50px;*/
    margin-bottom: 45px;
  }
  .el-button{
    width: 360px;
  }
  .el-tabs__item{
    font-size: 20px;
  }
  .inpup_first{
    margin-top: 30px;
  }
  .fiex{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom:260px;
  }
  .main {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
  .el-footer .link a {
    color: #999;
    text-decoration: none;
  }
  .user_tabs{
    margin-top: 30px;
  }
  .next{
    color: #ffffff;
    text-decoration: none;
  }
  .tpcode_div{
    width: 110px;
    height: 40px;
    margin: -20px;
    cursor: pointer
  }
  
  .input_err_tips{
    margin-bottom: 15px;
    text-align:left;
    display:block;
    color:red;
    font-size: 15px;
    height: 30px;
  }

  @media screen and (max-width: 1500px) {
  .logo_header_box {
    display: block;
    position: relative;
    height: 57px;
    width: 1250px;
    margin: 0px 200px;
  }
}

@media screen and (max-width: 760px) {
  .logo_header_box {
    display: block;
    position: relative;
    height: 57px;
    margin: 0;
  }
  .next_to{
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resetpwd.vue